import { reaction } from 'mobx';
import { useStores } from 'mobx/useStores';
import { useEffect, useState } from 'react';

interface UseShopHook {
  shop: any;
}

export const useShop = (): UseShopHook => {
  const { shopStore } = useStores();
  const [shop, setShop] = useState<any | null>(shopStore.shop);

  // Listen for changes in the store here because we can't use the observer HOC in a hook
  useEffect(() => {
    const disposers: (() => void)[] = [];

    disposers.push(
      reaction(
        () => shopStore.shop,
        (val) => setShop(val),
      ),
    );

    return () => {
      disposers.forEach((disposer) => disposer());
    };
  }, []);

  return {
    shop,
  };
};
